import {HttpParams} from '@angular/common/http';

/**
 * Agrega al HttpParams la/las columnas por las que se quiere acotar la busqueda del filtro.
 *
 * Acepta una sola columna ('nombre') o varias (['nombre', 'descripcion']). Cuando son varias
 * se repite la clave en la query string, que es la forma que el backend (Express + qs) parsea
 * como array:
 *
 * ```
 * ?filtro=binder&columnaFiltro=nombre&columnaFiltro=descripcion
 * ```
 *
 * El backend busca con OR entre las columnas indicadas. Si no se pasa ninguna, los params
 * quedan sin tocar y el backend busca en todas las columnas filtrables del recurso.
 *
 * Obs: cada columna tiene que estar declarada como filtrable en el route file del backend,
 * caso contrario el endpoint responde 400 indicando cuales son las validas.
 *
 * @param params HttpParams al que se le agregan las columnas
 * @param columnaFiltro columna o columnas por las que filtrar
 */
export function agregarColumnaFiltro(params: HttpParams, columnaFiltro?: string | string[]): HttpParams {
  let columnas: string[];
  if (Array.isArray(columnaFiltro)) {
    columnas = columnaFiltro;
  } else {
    columnas = columnaFiltro ? [columnaFiltro] : [];
  }
  return columnas
    .filter(columna => !!columna)
    .reduce((acc, columna) => acc.append('columnaFiltro', columna), params);
}
